export enum AuthActionType {
    LOGIN = "LOGIN",
    REGISTRATION = "REGISTRATION"
}
